import React, {useContext, useEffect, useState} from "react";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import MaterialTable from "material-table";
import {httpRequestWithAuth} from "../../auth/axios_instance";
import {BaseFixClassAttendanceWithoutAttendanceURL, BaseViewClassAttendanceURL} from "../../urls";
import Button from "@material-ui/core/Button";
import {DateField} from "../../components/fields/DateField";
import Toolbar from "@material-ui/core/Toolbar";
import {CheckBox} from "@material-ui/icons";
import {CustomCheckBox} from "../../components/CustomCheckBox";
import moment from "moment";
import {not_validate_value} from "../../App";
import {AlertContext} from "../../store/use_context";


export const ViewClassAttendance = props =>{
    const {setAlert} = useContext(AlertContext);

    const columns = [
        {title: "Client", field: 'client_name'},
        {title: "Is present", field: 'is_present'},
        {title: "Is cancelled", field: 'is_cancelled'},
        {title: "Date", field: 'date_view'},
        {title: "Added by", field: 'added_by_name'},
        {title: "Cancelled by", field: 'cancelled_by_name'},
    ];

    const [data, setData] = useState([]);
    const [is_loading, setIsloading] = useState(false);
    const [filter, setFilter] = useState({
        without_entity: true,
        from_date: moment(),
        to_date: moment().add(7, 'days'),
    });
    const [fetch_data, setFetchData] = useState(false);

    const handleFilterChange = (name, value) =>{
        setFilter({...filter, [name]: value})
    }

    useEffect(()=>{
        const fetchData = async ()=>{
            await setIsloading(true);
            let temp_filter = {};

            if (!not_validate_value.includes(filter.from_date)){
                temp_filter['from_date'] = moment(filter.from_date).format("YYYY-MM-DD")
            }

            if (!not_validate_value.includes(filter.to_date)){
                temp_filter['to_date'] = moment(filter.to_date).format("YYYY-MM-DD")
            }

            if (!not_validate_value.includes(filter.without_entity) && filter.without_entity){
                temp_filter['without_entity'] = filter.without_entity
            }

            let response = await httpRequestWithAuth(BaseViewClassAttendanceURL, "GET", null, temp_filter);
            if (response.status){
                setData(response.data);
            }
            await setIsloading(false);
        }
        fetchData();
    },[fetch_data]);


    let filter_fields = (
        <>
                <Grid item xs={12} md={6}>
                    <DateField
                        label="From date"
                        name="from_date"
                        // inputVariant="standard"
                        value={filter.from_date || null}
                        onChangeHandle={handleFilterChange}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <DateField
                        label="To date"
                        name="to_date"
                        min_date={filter.from_date}
                        // inputVariant="standard"
                        value={filter.to_date || null}
                        onChangeHandle={handleFilterChange}
                    />
                </Grid>

                <Grid item xs={12}>
                    <CustomCheckBox
                        value={filter.without_entity}
                        name='without_entity'
                        onChangeHandle={handleFilterChange}
                        label="Without entity"
                    />
                </Grid>

                <Grid item xs={12}>
                    <Button
                        variant="outlined"
                        color='primary'
                        size="large"
                        fullWidth
                        onClick={()=>setFetchData(!fetch_data)}
                    >
                        Filter
                    </Button>
                </Grid>

</>
    );


    return(
        <Paper className="flex-column align-items-center d-flex Paper">
            <Grid container spacing={2} className="mt-5">
                {filter_fields}
                <Grid item xs={12}>
                    <MaterialTable
                        title="Class Attendance"
                        columns={columns}
                        data={data}
                        isLoading={is_loading}

                        actions={[
                            {
                                icon: ()=>(
                                    <Button
                                    color="primary"
                                    onClick={async ()=>{
                                        await setIsloading(true)
                                        let response = await httpRequestWithAuth(BaseFixClassAttendanceWithoutAttendanceURL, "PATCH");
                                        if (response.status){
                                            setAlert("Done");
                                            await setFetchData(!fetch_data);
                                        }
                                        await setIsloading(false);
                                    }}
                                    variant="contained"
                                    >
                                        Fix all attendance without entity
                                    </Button>
                                ),
                                isFreeAction: true
                            },

                        ]}
                        style={{
                            padding: "0.5rem",
                            boxShadow: "none",
                        }}

                        options={{
                            showTitle: false,
                            searchFieldAlignment: 'left',
                            actionsColumnIndex: -1,
                            paging: false,
                        }}
                    />
                </Grid>
            </Grid>
        </Paper>
    )
}
